import './divider.scss';

export const Divider = (props) => {
    const { content } = props;

    return <div data-content={content} className="divider" />;
};
